export enum CompanyRevocationMajority {
  UNANIMITY = 'UNANIMITY',
  MAJORITY_2_THIRD = 'MAJORITY_2_THIRD',
  MAJORITY_VOICE = 'MAJORITY_VOICE',
}
